import React, { createContext, useContext, useState, useCallback } from 'react';

interface WorkflowSearchContextType {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  clearSearch: () => void;
}

const WorkflowSearchContext = createContext<WorkflowSearchContextType | undefined>(undefined);

export function WorkflowSearchProvider({ children }: { children: React.ReactNode }) {
  const [searchTerm, setSearchTerm] = useState('');

  const clearSearch = useCallback(() => {
    setSearchTerm('');
  }, []);

  return (
    <WorkflowSearchContext.Provider value={{ searchTerm, setSearchTerm, clearSearch }}>
      {children}
    </WorkflowSearchContext.Provider>
  );
}

export function useWorkflowSearch() {
  const context = useContext(WorkflowSearchContext);
  if (context === undefined) {
    throw new Error('useWorkflowSearch must be used within a WorkflowSearchProvider');
  }
  return context;
}
